export const isInIframe = window.self !== window.top

// https://stackoverflow.com/a/34073811
export function isInSandboxedIframe() {
  if (window.parent === window) return false
  let f: Element | null
  try {
    f = window.frameElement
  } catch (err) {
    f = null
  }

  if (f === null) {
    // Probably 'non-sandboxed'
    if (document.domain !== '') return false
    if (location.protocol !== 'data:') return true

    // Can be 'sandboxed' on Firefox
    return true
  }
  return f.hasAttribute('sandbox') ? true : false
}
